module.exports = __webpack_public_path__ + "img/openai-svgrepo-com.c000368e.svg";